export const getPermission = (accesslist, module) => {
  return accesslist?.some(
    person => person.permission_key === module && person.permission_value,
  );
};
